// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

//Load Libraries
// require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');

//Load Modules
require('./modules/accordion');
// require('./modules/not-in-use/animatein');
// require('./modules/not-in-use/bannerVideo');
require('./modules/formInputs');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/menu');
// require('./modules/not-in-use/modal');
// require('./modules/not-in-use/scrollTo');
// require('./modules/not-in-use/shareSocial');
// require('./modules/not-in-use/sideMenu');
// require('./modules/not-in-use/tabs');
// require('./modules/not-in-use/alert');
// require('./modules/not-in-use/handlebars');
require('./modules/sliders');
require('./modules/buttons');
require('./modules/inpagenav');
require('./modules/stickynav');
require('./modules/cardsMatchHeight');
require('./modules/modal');
